angular.module('impactx.productgroup').component('ixProductGroupNestedTreeList', {
        bindings: {
            entry: '<',
            expand: '&',
            editEntry: '&',
            deleteEntry: '&',
            editPriceEntry: '&',
            addEntry: '&',
            exportArticleSheet: '&',
            noPriceRule: "=",
            enableTreeChanges: "=",
            enableOnlyTreeAdd: "=",
            disableExportArticleSheet: "=",
            disableEdit: "="
        },
        controller: 'ProductGroupNestedTreeListCtrl',
        templateUrl: 'modules/productgroup/templates/nested-product-group-tree-list.html'
    }
);